// Mock data for 365 Transportation Landing Page

export const trustIndicators = [
  { icon: "CheckCircle2", text: "Fully Compliant Vehicles" },
  { icon: "Users", text: "Certified Drivers" },
  { icon: "Heart", text: "Trauma-Informed Training" },
  { icon: "Building2", text: "District Partnerships" },
  { icon: "Award", text: "SELPA Experience" }
];

export const coreServices = [
  {
    id: 1,
    title: "Specialized Student Transportation",
    description: "Safe, structured transportation for students with autism, behavioral, emotional, and physical needs.",
    icon: "Bus"
  },
  {
    id: 2,
    title: "Trauma-Informed Care",
    description: "Staff trained to understand emotional triggers, lived experiences, and de-escalation techniques.",
    icon: "HeartHandshake"
  },
  {
    id: 3,
    title: "Behavior-Sensitive Routing",
    description: "Strategic rider grouping and proactive planning to ensure compatibility and safety.",
    icon: "Route"
  },
  {
    id: 4,
    title: "10-Passenger Van Alternative",
    description: "Comfortable passenger vans offering a more personalized alternative to traditional school buses for specialized student needs.",
    icon: "Truck"
  },
  {
    id: 5,
    title: "Family & School Collaboration",
    description: "Seamless communication with families and district teams to support consistency.",
    icon: "MessageCircle"
  },
  {
    id: 6,
    title: "Safety & Compliance Excellence",
    description: "Fully compliant vehicles, certified drivers, and strict adherence to protocols.",
    icon: "Shield"
  }
];

export const differentiators = [
  {
    title: "Whole Child Philosophy",
    description: "We recognize that every behavior is communication, and every child deserves understanding."
  },
  {
    title: "Intentional Hiring Model",
    description: "We hire for character, empathy, and resilience—then train for technical excellence."
  },
  {
    title: "Experience with High-Needs Populations",
    description: "20+ years serving students with complex behavioral, emotional, and physical needs."
  },
  {
    title: "Consistency & Stability",
    description: "Dedicated drivers and consistent routes build trust and reduce anxiety."
  },
  {
    title: "Proactive Incident Prevention",
    description: "Strategic planning and continuous training minimize disruptions before they happen."
  }
];

export const metrics = [
  { value: "20+", label: "Years Experience" },
  { value: "30-55", label: "Mile Specialized Routes" },
  { value: "100%", label: "Compliance Focus" },
  { value: "24/7", label: "Support Available" }
];

export const trainingTopics = [
  { icon: "Brain", text: "Autism & Behavioral Support Training" },
  { icon: "Heart", text: "Trauma-Informed Practices" },
  { icon: "Globe", text: "Cultural Competency" },
  { icon: "Shield", text: "De-escalation Techniques" },
  { icon: "AlertCircle", text: "Safety & Emergency Procedures" }
];

export const faqs = [
  {
    question: "What makes 365 Transportation different from other student transportation providers?",
    answer: "We are not just a transportation company—we are a student support service. Our staff is trained in trauma-informed care, de-escalation techniques, and behavioral support. We understand that behavior is communication, and we approach every ride with empathy, patience, and professionalism."
  },
  {
    question: "What training do your drivers receive?",
    answer: "All drivers undergo comprehensive training including autism and behavioral support, trauma-informed practices, cultural competency, de-escalation techniques, and safety/emergency procedures. We hire for character and train for excellence, ensuring every team member understands the complexities of working with students with specialized needs."
  },
  {
    question: "How do you handle behavioral incidents?",
    answer: "We take a proactive approach to incident prevention through strategic rider grouping, consistent routines, and well-trained staff. When challenges arise, our team uses de-escalation techniques and trauma-informed approaches. We maintain open communication with families and schools to ensure coordinated support."
  },
  {
    question: "Are your vehicles compliant with safety regulations?",
    answer: "Yes, 100%. All vehicles meet or exceed federal and state safety standards. We maintain strict compliance protocols, conduct regular inspections, and ensure all equipment is current and functional. Safety is our highest priority."
  },
  {
    question: "How do you ensure compatibility between students on the same route?",
    answer: "We use behavior-sensitive routing strategies, carefully considering each student's needs, triggers, and compatibility factors. Our planning process is intentional and collaborative, working with families and schools to create the safest and most supportive environment possible."
  },
  {
    question: "Do you work with SELPAs and school districts?",
    answer: "Yes, we have extensive experience partnering with Special Education Local Plan Areas (SELPAs) and school districts. We understand compliance requirements, IEP considerations, and the importance of seamless collaboration between transportation and educational teams."
  },
  {
    question: "Can families track their child's transportation in real-time?",
    answer: "We are actively developing a real-time tracking platform that will provide families and districts with visibility into ride status, location updates, and communication tools. This technology is designed to provide peace of mind and enhance transparency."
  },
  {
    question: "What is your service area?",
    answer: "We specialize in routes ranging from 30-55 miles and serve school districts and families throughout California. Contact us to discuss your specific location and needs."
  },
  {
    question: "How do you communicate with families and schools?",
    answer: "We maintain open, proactive communication through multiple channels. Our team provides regular updates, incident reports when necessary, and maintains strong relationships with both families and school staff to ensure consistency and support."
  },
  {
    question: "What if my child has very complex needs?",
    answer: "Complex needs are our specialty. We have 15+ years of experience supporting students with autism, severe behavioral challenges, emotional disabilities, and medical needs. We work closely with families and care teams to develop individualized support plans for every child."
  }
];

export const mockRides = [
  {
    id: "R-2024-001",
    student: "Student A",
    route: "Route 12 - North District",
    status: "completed",
    pickup: "7:45 AM",
    dropoff: "8:30 AM",
    driver: "John Martinez"
  },
  {
    id: "R-2024-002",
    student: "Student B",
    route: "Route 7 - East District",
    status: "en-route",
    pickup: "7:50 AM",
    eta: "8:35 AM",
    driver: "Sarah Johnson"
  },
  {
    id: "R-2024-003",
    student: "Student C",
    route: "Route 12 - North District",
    status: "scheduled",
    pickup: "8:00 AM",
    scheduled: "8:45 AM",
    driver: "John Martinez"
  }
];

export const dashboardStats = {
  totalRides: 247,
  activeRoutes: 8,
  onTimeRate: 98.5,
  incidents: 2
};
